import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody} from 'reactstrap';
import AccumulatorForm from '../device/accumulator-form';
import useSaveAccumulator from '../../hooks/use-save-accumulator';

/**
 * Janela de edicao de odometro e horimetro aberta a partir do card do dispositivo em /client.
 *
 * SECURITY: a janela so e oferecida a quem pode editar (`canEditAccumulators`); o servidor decide de novo a cada
 * edicao. Fica aberta quando o servidor recusa, para o usuario corrigir o valor.
 */
const AccumulatorModal = ({device, isOpen, close}) => {
    const {save: saveAccumulator, saving} = useSaveAccumulator();
    const deviceId = device?.id;

    // A janela aberta nao sobrevive a troca ou a saida do dispositivo: sem isto, escolher outro dispositivo depois
    // a abriria sozinha.
    useEffect(() => () => close(), [deviceId]);

    const onSave = async (accumulator) => {
        if (await saveAccumulator(accumulator)) {
            close();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={close} size="lg" centered unmountOnClose>
            <ModalBody>
                {device && (
                    <AccumulatorForm data={device} saveAccumulator={onSave} cancel={close} loading={saving} />
                )}
            </ModalBody>
        </Modal>
    );
};

AccumulatorModal.propTypes = {
    device: PropTypes.object,
    isOpen: PropTypes.bool,
    close: PropTypes.func.isRequired,
};

export default AccumulatorModal;
